"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _startsWith = _interopRequireDefault(require("lodash/startsWith"));

var _values = _interopRequireDefault(require("lodash/values"));

var _shuffle = _interopRequireDefault(require("lodash/shuffle"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _slice = _interopRequireDefault(require("lodash/slice"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
} // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions


var Fragment = _react["default"].Fragment; // ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------

/** GalleryX */

var GalleryX = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GalleryX, _React$Component);
  /** standard constructor */


  function GalleryX(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      client: false
    };
    return _this;
  }
  /** after mount */


  var _proto = GalleryX.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      client: true
    });
  }
  /** standard renderer */
  ;

  _proto.render = function render() {
    var client = this.state.client;
    var _this$props = this.props,
        _this$props$data = _this$props.data,
        data = _this$props$data === void 0 ? [] : _this$props$data,
        _this$props$lookup = _this$props.lookup,
        lookup = _this$props$lookup === void 0 ? 'image' : _this$props$lookup,
        _this$props$columns = _this$props.columns,
        columns = _this$props$columns === void 0 ? {
      min: 2,
      max: 3
    } : _this$props$columns,
        _this$props$imageWidt = _this$props.imageWidth,
        imageWidth = _this$props$imageWidt === void 0 ? 600 : _this$props$imageWidt,
        Img = _this$props.Img,
        _this$props$margin = _this$props.margin,
        margin = _this$props$margin === void 0 ? 2 : _this$props$margin,
        _this$props$conf = _this$props.conf,
        conf = _this$props$conf === void 0 ? {} : _this$props$conf,
        MediaQuery = _this$props.MediaQuery,
        Gallery = _this$props.Gallery,
        _this$props$galleryPr = _this$props.galleryProps,
        galleryProps = _this$props$galleryPr === void 0 ? {} : _this$props$galleryPr;
    var _conf$shuffle = conf.shuffle,
        shuffle = _conf$shuffle === void 0 ? false : _conf$shuffle,
        _conf$max = conf.max,
        max = _conf$max === void 0 ? undefined : _conf$max;
    var temp = (0, _values["default"])((0, _pickBy["default"])(data, function (value, key) {
      return (0, _startsWith["default"])(key, lookup);
    }));
    var photos = [];
    temp.map(function (d) {
      return photos.push(_extends({}, d, {
        src: d.childImageSharp.fluid.src,
        width: imageWidth,
        height: Math.round(imageWidth / d.childImageSharp.fluid.aspectRatio)
      }));
    });

    if (shuffle === true) {
      photos = (0, _shuffle["default"])(photos);
    }

    if ((0, _isUndefined["default"])(max) === false) {
      photos = (0, _slice["default"])(photos, 0, max);
    }
    /** ImageX */


    var ImageX = function ImageX(_ref) {
      var index = _ref.index,
          onClick = _ref.onClick,
          photo = _ref.photo,
          margin = _ref.margin;
      return /*#__PURE__*/_react["default"].createElement(Img, {
        fluid: photo.childImageSharp.fluid,
        style: {
          width: photo.width,
          height: photo.height,
          margin: margin
        }
      });
    };

    return /*#__PURE__*/_react["default"].createElement(Fragment, null, client === true && /*#__PURE__*/_react["default"].createElement(Fragment, null, /*#__PURE__*/_react["default"].createElement(MediaQuery, {
      minWidth: 1024
    }, function (matches) {
      return /*#__PURE__*/_react["default"].createElement(Gallery, _extends({
        photos: photos,
        columns: matches === true ? columns.max : columns.min // columns={columns.max}
        ,
        ImageComponent: ImageX,
        margin: margin
      }, galleryProps));
    })), client === false && /*#__PURE__*/_react["default"].createElement(Fragment, null, /*#__PURE__*/_react["default"].createElement(Gallery, _extends({
      photos: photos,
      columns: columns.max,
      ImageComponent: ImageX,
      margin: margin
    }, galleryProps))));
  };

  return GalleryX;
}(_react["default"].Component); // ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------


var _default = GalleryX;
exports["default"] = _default;
module.exports = exports.default;